<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex align-self-center text-center>
        <!-- <v-card> -->

        <span class="itemHeading">Video - HomePage</span>
        <v-spacer></v-spacer>

        <v-layout wrap justify-start py-3>
          <v-flex xs12>
            <v-flex xs12 md12 text-left>
              <span class="textField1"
                >Enter 'Embed' video url from youtube to display on the
                website</span
              >
              <br />
              <br />
              <v-text-field
                dense
                outlined
                placeholder="Paste 'Embed' youtube video url here"
                :color="appColor"
                v-model="vurl"
              ></v-text-field>
              <!-- <div id="app">
                <vue-editor v-model="content"></vue-editor>
              </div> -->
            </v-flex>
            <v-flex xs12 md12 text-left>
              <span class="textField1"
                >Enter 'Video' title to display on website</span
              >
              <br />
              <br />
              <v-text-field
                dense
                outlined
                placeholder="Paste 'Embed' youtube video url here"
                :color="appColor"
                v-model="name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md12 text-left>
              <span class="textField1"
                >Enter 'Video' content to display on website</span
              >
              <br />
              <br />
              <div id="app">
                <vue-editor v-model="content"></vue-editor>
              </div>
            </v-flex>
            <v-flex xs12 align-self-center text-center pa-6>
              <v-btn tile dark :color="appColor" @click="addVideo()">
                Save
              </v-btn>
            </v-flex>
            <v-flex xs12 pa-4 v-if="vurl">
              <iframe width="1080" height="480" :src="vk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
              <!-- <span v-html="vurl"></span> -->
            </v-flex>
          </v-flex>
        </v-layout>
        <!-- </v-card> -->
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
// import ImageComp from  "@/components/Common/singleImage";
import axios from "axios";
export default {
  data() {
    return {
      showsnackbar: false,
      ServerError: false,
      msg: null,
      pages: 0,
      dialog: false,
      editdialog: false,
      editingitem: [],
      pageCount: 1,
      appLoading: false,
      editedIndex: -1,
      currentPage: 1,
      g: false,
      perPage: 4,
      totalData: 0,
      totalRows: 0,
      dialogDelete: false,
      search: "",
      itemname: "",
      addcat: false,

      rules: {
        required: (value) => !!value || "Required.",
      },
      vurl: null,
      vk:null,
      name:null,
      content:null,

    };
  },
  components: {
    // ImageComp,
  },
  watch: {
    vurl() {
      if (this.vurl) {
        var str=this.vurl
        var regex = /<iframe.*?src="(.*?)"/;
        var src = regex.exec(str)[1];

        console.log(src);
        this.vk=src
      }
    },
  },
  mounted() {
    this.getData();
  },

  methods: {
    getData() {
      this.appLoading = true;
      axios({
        url: "/video/getlist",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.vurl = response.data.data.videourl;
          this.name = response.data.data.name;
          this.content = response.data.data.content;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    addVideo() {
      var data = {};
      data["videourl"] = this.vurl;
      data["content"] = this.content;
      data["name"] = this.name;
      axios({
        url: "/video/add/edit",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Added Sucessfully";
            this.showsnackbar = true;
            this.name = null;
            this.dialog = false;
            this.getData();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
